import * as types from "../actions/actionTypes";
const initialState = {
  loading: false,
  is_fetched:false,
  data: [],
  accountingSoftware: [],
  sharedContacts: [],
  userState: [],
  useStateLoading: false
};

const ProjectSetting = (state = initialState, action) => {
  switch (action.type) {

    case types.PROJECT_SETTING_STORE_REQUEST:
      return { ...state, loading: true };
    case types.PROJECT_SETTING_STORE_SUCCESS:
      return { ...state, data:action.payLoad,loading: false };
    case types.PROJECT_SETTING_STORE_FAILURE:
      return { ...state, loading: false };

    case types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_REQUEST:
      return { ...state, loading: true };
    case types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_SUCCESS:
      return { ...state, accountingSoftware:action.payLoad,loading: false };
    case types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_FAILURE:
      return { ...state, loading: false };

    case types.SHARED_CONTACTS_REQUEST:
      return { ...state, loading: true };
    case types.SHARED_CONTACTS_SUCCESS:
      return { ...state, sharedContacts:action.payLoad, loading: false };
    case types.SHARED_CONTACTS_FAILURE:
      return { ...state, loading: false };

    case types.SET_USER_STATE_REQUEST:
      return { ...state, useStateLoading: true };
    case types.SET_USER_STATE_SUCCESS:
      return { ...state, userState:action.payLoad, useStateLoading: false };
    case types.SET_USER_STATE_FAILURE:
      return { ...state, userState:action.payLoad, useStateLoading: false};
    default:
      return state;
  }
};

export default ProjectSetting;

